import React, { useState } from 'react'

import { Table, Tooltip, Divider, Popconfirm, message } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEdit, faTrash } from '@fortawesome/free-solid-svg-icons'

import EditPromoDetailModal from './EditPromoDetailModal'
import { deletePromoDetail } from '../services'
import { handleError } from '../../../helpers'

export default function PromoDetailsTable({ promoDetails, reload }) {	
	const [editPromoDetail, setEditPromoDetail] = useState(null)

	const handleDelete = id => {
		deletePromoDetail(id)
			.then(() => {
				message.success('Detalle de dinámica eliminada exitosamente')
				reload()
			})
			.catch(error => handleError(error))
	}

	const columns = [
		{
			title: 'Descripción',
			dataIndex: 'description'
		},
		{
			title: 'Material de Comunicación',
			dataIndex: 'sales_tools',
			render: t => t ? t : <em>Sin material</em>
		},
		{
			title: 'Acciones',
			render: (t, record) => (
				<React.Fragment>
					<Tooltip title="Editar">
						<FontAwesomeIcon 
							className="text-link" 
							icon={faEdit} 
							onClick={()=>setEditPromoDetail(record)} 
						/>
					</Tooltip>
					<Divider type="vertical" />
					<Popconfirm 
						title="¿Desea eliminar registro?"
						okText="Eliminar"
						cancelText="Cancelar"
						onConfirm={() => handleDelete(record.id)}
						okButtonProps={{ danger:true }}
					>
						<FontAwesomeIcon className="text-link" icon={faTrash} />
					</Popconfirm>
				</React.Fragment>
			)
		}
	]

	return (
		<React.Fragment>
			<Table 
				dataSource={promoDetails}
				columns={columns}
				rowKey={record => record.id}
				size="small"
				expandable={{
					expandedRowRender: record => <p className="mb-0">
						<strong>Términos y Condiciones:</strong> {record.terms ? record.terms : <em>Sin términos y condiciones registrados</em>}
					</p>,
				 }}
			/>
			<EditPromoDetailModal 
				visible={editPromoDetail ? true : false}
				onClose={()=>setEditPromoDetail(null)}
				promoDetail={editPromoDetail}
				reload={reload}
			/>
		</React.Fragment>
	)
}